import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import { SortableListContainer } from '../../../modules/sortable/index'
import LinkListToolbar from './LinkListToolbar'
import LinkListItem from './LinkListItem'
import AddLinkListItem from './AddLinkListItem'
import { addLink } from '../../../actions/portal'

class LinkList extends React.Component {
  state = {
    unsavedLink: false,
  }

  handleLinkSort = links => {
    this.props.updatePortalAtPath('links', links)
  }

  handleAddEmptyLink = () => {
    if (!this.state.unsavedLink) this.setState({ unsavedLink: true })
  }

  handleSaveLink = link => {
    this.props.addLink(link)
    this.setState({ unsavedLink: false })
  }

  render() {
    return (
      <div>
        <LinkListToolbar onAddLink={this.handleAddEmptyLink} />
        <hr />
        {this.state.unsavedLink && (
          <AddLinkListItem onSaveLink={this.handleSaveLink} />
        )}
        <SortableListContainer
          items={this.props.portal.links}
          itemsDidSorted={this.handleLinkSort}
          itemComponent={LinkListItem}
        />
      </div>
    )
  }
}

export default compose(connect(null, { addLink }), withPortalAutoRemoteSync())(
  LinkList,
)



// WEBPACK FOOTER //
// ./src/components/templates/link-list/LinkList.js